// Centralised contact / brand info — easy to edit later
export const SITE = {
    name: "Dacron Classes",
    tagline: "Pathankot's Premier Coaching Institute",
    phone: "+91 82640 31180",
    phoneRaw: "+918264031180",
    whatsapp: "918264031180",
    email: "info@dacronclasses.in",
    address: "Main Bazar Road, Near Nangal Chowk, Pathankot, Punjab 145001",
    city: "Pathankot",
    state: "Punjab",
    mapEmbed:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3367.8892856437637!2d75.65221!3d32.27465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391b7e36f5a25555%3A0x4f5a5f7d2d6f8b8c!2sPathankot%2C%20Punjab!5e0!3m2!1sen!2sin!4v1700000000000",
    gbpUrl: "https://www.google.com/maps/search/Dacron+Classes+Pathankot",
    domain: "https://dacron-coaching-hub.preview.emergentagent.com",
};

export const waLink = (msg = "Hi Dacron Classes, I want to enquire about coaching") =>
    `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:${SITE.phoneRaw}`;
export const mailLink = `mailto:${SITE.email}`;
